export const ACCOUNT_PATH = '/account'
export const LOGIN_PATH = '/login'
export const SIGNUP_PATH = '/signup'

export const WORDBANKS_PATH = '/wordbanks'
export const WORDS_PATH = '/words'
